import getSearchedLocation from '@location/selectors/getSearchedLocation';
import { QUERY_PARAM } from '@commons/constants';
import { getResultsRoute, ROUTES } from '@services/routes.service';
import { pushPage } from '@shared/actions';
import queryString from 'query-string';

const navigateToVerticalResults = (businessType, paymentTypeId) => (
  dispatch,
  getState,
) => {
  const location = getSearchedLocation(getState());
  if (!location) {
    dispatch(pushPage(ROUTES.HOME));
    return;
  }
  let route = getResultsRoute(location);
  if (businessType) {
    const businessTypeQueryParam = queryString.stringify({
      [QUERY_PARAM.BUSINESS_TYPE]: businessType,
    });
    route += `&${businessTypeQueryParam}`;
  }
  if (paymentTypeId) {
    const businessTypeQueryParam = queryString.stringify({
      [QUERY_PARAM.PAYMENTS]: paymentTypeId,
    });
    route += `&${businessTypeQueryParam}`;
  }
  dispatch(pushPage(route));
};

export default navigateToVerticalResults;
